module.exports = __webpack_public_path__ + "static/media/Contact.3634f2bf.png";